<template>
  <section>
    <div>
    <!-- <div class="chart--grid"> -->
      <!-- <v-card class="chartDefault">
      </v-card> -->
      <!-- <v-card class="chartDefault">
        <canvas id="evotingStats" />
      </v-card> -->
    </div>
    <div class="dash--main">
      <h2>Welcome To Admin</h2>
      <!-- List View Design Below -->

      <!-- <v-card class="activity--main">
        <div class="dash--header primary white--text">
          <p class="dash--title">Activities</p>
          <p class="dash--sub-title">List Of Todays Activities</p>
        </div>
        <div class="activity--content-list">

          <v-card flat class="activity--card pending">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Event</p>
            <p class="activity--sub-title">20-08-2018</p>
            <div class="pos-right-top">
              <p class="activity--status">Pending</p>
            </div>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="mr-0 mt-2">Mark As Done</v-btn>
              <v-btn depressed round color="primary" class="mr-0 mt-2">View</v-btn>
            </div>
          </v-card>

          <v-card flat class="activity--card pending">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Event</p>
            <p class="activity--sub-title">20-08-2018</p>
            <div class="pos-right-top">
              <p class="activity--status">Pending</p>
            </div>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="mr-0 mt-2">Mark As Done</v-btn>
              <v-btn depressed round color="primary" class="mr-0 mt-2">View</v-btn>
            </div>
          </v-card>

          <v-card flat class="activity--card done">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Call</p>
            <p class="activity--sub-title">20-08-2018</p>
            <div class="pos-right-top">
              <p class="activity--status">Done</p>
            </div>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="mr-0 mt-2">Mark As UnDone</v-btn>
              <v-btn depressed round color="primary" class="mr-0 mt-2">View</v-btn>
            </div>
          </v-card>

          <v-card flat class="activity--card done">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Call</p>
            <p class="activity--sub-title">20-08-2018</p>
            <div class="pos-right-top">
              <p class="activity--status">Done</p>
            </div>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="mr-0 mt-2">Mark As UnDone</v-btn>
              <v-btn depressed round color="primary" class="mr-0 mt-2">View</v-btn>
            </div>
          </v-card>

          <v-card flat class="activity--card done">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Call</p>
            <p class="activity--sub-title">20-08-2018</p>
            <div class="pos-right-top">
              <p class="activity--status">Done</p>
            </div>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="mr-0 mt-2">Mark As UnDone</v-btn>
              <v-btn depressed round color="primary" class="mr-0 mt-2">View</v-btn>
            </div>
          </v-card>

          <v-card flat class="activity--card done">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Call</p>
            <p class="activity--sub-title">20-08-2018</p>
            <div class="pos-right-top">
              <p class="activity--status">Done</p>
            </div>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="mr-0 mt-2">Mark As UnDone</v-btn>
              <v-btn depressed round color="primary" class="mr-0 mt-2">View</v-btn>
            </div>
          </v-card>

        </div>
      </v-card> -->

      <!-- List View Design End -->

      <!-- Drag and Drop Design Below -->

      <!-- <v-card class="activity--main">
        <div class="dash--header primary white--text">
          <p class="dash--title">Activities</p>
          <p class="dash--sub-title">List Of Todays Activities</p>
        </div>
        <div class="dash--grid">

          <div>
            <div class="dash--header">
              <p class="dash--title">Pending</p>
              <p class="dash--sub-title">Drag Here To Mark It Undone</p>
            </div>
            <div class="activity--content">


              <v-card flat class="activity--card pending">
                <p class="activity--title">Title Of Activity</p>
                <p class="activity--sub-title">Event</p>
                <p class="activity--sub-title">20-08-2018</p>
                <div class="pos-right">
                  <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
                </div>
              </v-card>

              <v-card flat class="activity--card pending">
                <p class="activity--title">Title Of Activity</p>
                <p class="activity--sub-title">Event</p>
                <p class="activity--sub-title">20-08-2018</p>
                <div class="pos-right">
                  <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
                </div>
              </v-card>

              <v-card flat class="activity--card pending">
                <p class="activity--title">Title Of Activity</p>
                <p class="activity--sub-title">Event</p>
                <p class="activity--sub-title">20-08-2018</p>
                <div class="pos-right">
                  <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
                </div>
              </v-card>

              <v-card flat class="activity--card pending">
                <p class="activity--title">Title Of Activity</p>
                <p class="activity--sub-title">Event</p>
                <p class="activity--sub-title">20-08-2018</p>
                <div class="pos-right">
                  <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
                </div>
              </v-card>

              <v-card flat class="activity--card pending">
                <p class="activity--title">Title Of Activity</p>
                <p class="activity--sub-title">Event</p>
                <p class="activity--sub-title">20-08-2018</p>
                <div class="pos-right">
                  <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
                </div>
              </v-card>

            </div>
          </div>

          <div>
            <div class="dash--header">
              <p class="dash--title">Done</p>
              <p class="dash--sub-title">Drag Here To Mark It Done</p>
            </div>

            <div class="activity--content">

              <v-card flat class="activity--card done">
                <p class="activity--title">Title Of Activity</p>
                <p class="activity--sub-title">Event</p>
                <p class="activity--sub-title">20-08-2018</p>
                <div class="pos-right">
                  <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
                </div>
              </v-card>

              <v-card flat class="activity--card done">
                <p class="activity--title">Title Of Activity</p>
                <p class="activity--sub-title">Event</p>
                <p class="activity--sub-title">20-08-2018</p>
                <div class="pos-right">
                  <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
                </div>
              </v-card>

              <v-card flat class="activity--card done">
                <p class="activity--title">Title Of Activity</p>
                <p class="activity--sub-title">Event</p>
                <p class="activity--sub-title">20-08-2018</p>
                <div class="pos-right">
                  <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
                </div>
              </v-card>

              <v-card flat class="activity--card done">
                <p class="activity--title">Title Of Activity</p>
                <p class="activity--sub-title">Event</p>
                <p class="activity--sub-title">20-08-2018</p>
                <div class="pos-right">
                  <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
                </div>
              </v-card>

              <v-card flat class="activity--card done">
                <p class="activity--title">Title Of Activity</p>
                <p class="activity--sub-title">Event</p>
                <p class="activity--sub-title">20-08-2018</p>
                <div class="pos-right">
                  <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
                </div>
              </v-card>


            </div>
          </div>
        </div>
      </v-card> -->


      <!-- Drag and Drop Design End -->

    </div>
    <!-- <div class="dash--main">
      <div class="dash--grid">
        <div>
          <v-date-picker
            v-model="date"
            full-width
            landscape
            color="primary"
          />
        </div>
        <div>
          <v-card class="dash--note">
            <div class="dash--header primary white--text">
              <p class="dash--title">Notes</p>
              <p class="dash--sub-title">Quick Notes</p>
            </div>
            <div class="dash--main note--content">
              <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Provident quos optio accusamus nesciunt minima recusandae
              officia exercitationem distinctio reiciendis sit fugiat architecto
              voluptate ipsam temporibus error a, et,
              suscipit debitis molestiae, sapiente laboriosam doloribus
              reprehenderit voluptatum expedita? Modi natus quos
              error distinctio tenetur facilis eius reiciendis doloribus cupiditate
              obcaecati nemo et eum amet id ex provident
              asperiores quibusdam nostrum, maiores aliquam dolorem.
              Aperiam harum explicabo sit sequi recusandae fugiat
              ullam quo voluptate animi, maxime velit natus odio repudiandae
              obcaecati voluptatem officiis veritatis enim,
              id culpa a. Eum at molestiae quasi excepturi error expedita eaque
              quidem repellat harum, aspernatur corrupti
              alias cum fugit placeat et laudantium debitis repellendus, illum ea
              consectetur distinctio sit id quas possimus?
              Fuga minus ex molestiae! Natus autem atque distinctio. Nisi vitae
              repudiandae quo fugiat
              </p>
            </div>
          </v-card>
        </div>
        <div/>
      </div>
    </div> -->

    <div>
      <!-- <v-dialog v-model="dialog" max-width="800px">
        <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>
        <v-card class="activity--modal">
          <p class="activity--title ml-3">List Of Activities For 15-08-2018</p>

          <v-card flat class="activity--card done">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Event</p>
            <p class="activity--sub-title">15-08-2018</p>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
            </div>
          </v-card>

          <v-card flat class="activity--card done">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Event</p>
            <p class="activity--sub-title">15-08-2018</p>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
            </div>
          </v-card>

          <v-card flat class="activity--card done">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Event</p>
            <p class="activity--sub-title">15-08-2018</p>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
            </div>
          </v-card>

          <v-card flat class="activity--card done">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Event</p>
            <p class="activity--sub-title">15-08-2018</p>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
            </div>
          </v-card>

          <v-card flat class="activity--card done">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Event</p>
            <p class="activity--sub-title">15-08-2018</p>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
            </div>
          </v-card>

          <v-card flat class="activity--card done">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Event</p>
            <p class="activity--sub-title">15-08-2018</p>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
            </div>
          </v-card>

          <v-card flat class="activity--card done">
            <p class="activity--title">Title Of Activity</p>
            <p class="activity--sub-title">Event</p>
            <p class="activity--sub-title">15-08-2018</p>
            <div class="pos-right">
              <v-btn depressed round color="primary" class="ml-0 mt-2">View</v-btn>
            </div>
          </v-card>

        </v-card>
      </v-dialog> -->
    </div>

  </section>
</template>
<script>
import dfns from "date-fns";
import { coreClient } from "../apollo";
import gql from "graphql-tag";

export default {
  methods: {},
  data() {
    return {
      dialog: null,
      date: null
    };
  }
};
</script>
<style lang="stylus" scoped>
@import '../assets/stylus/Dashboard.styl';

h2 {
  font-size: 3rem;
  font-weight: 700;
  line-height: 2rem;
  text-transform: uppercase;
  color: #333333;
  margin: 0;
  text-align: center;
  margin-top: 350px;
}
</style>
